module.exports = __webpack_public_path__ + "static/img/IMG_20160821_142000.b0421beb.jpg";